/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Bulk_Carrier_TitleInputs */



/**
* | output |
* | --- |
* | "Bulk carrier inspections" |
*
* @param {Service_Bulk_Carrier_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_bulk_carrier_title = /** @type {((inputs?: Service_Bulk_Carrier_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Bulk_Carrier_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("散货船检查")
	return /** @type {LocalizedString} */ ("Bulk carrier inspections")
});